import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {updateSearchSettings} from 'src/openapi/admin/apis/ConferenceSearchSettingsApi';
import {SearchSettingsType as SearchSettingsTypes} from 'src/openapi/admin/models/SearchSettingsType';
import {useAppDispatch} from 'src/store/hooks';

import type {SearchSettingsRequest} from 'src/openapi/admin/models/SearchSettingsRequest';
import type {SuccessPayload} from 'src/typedef';

type Props = {
    settingsId: number,
    initialData: SearchSettingsRequest,
};

const DEFAULT_FORM: SearchSettingsRequest = {
    conferenceId: 0,
    searchSettings: SearchSettingsTypes.COMPANY,
    name: '',
    pbIds: [],
};

export const useEditSearch = ({initialData, settingsId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        return Promise.resolve({type: '', payload: {
            success: true,
            error: false,
            data: initialData,
        } as SuccessPayload<SearchSettingsRequest>});
    }, [initialData]);

    const saveDispatchAction = useCallback((
        searchSettingsRequest: SearchSettingsRequest,
        signal: AbortSignal,
    ) => apiDispatch(
        updateSearchSettings({searchSettingsRequest, settingsId}, {signal}),
    ), [settingsId, apiDispatch]);

    return useCommonDataHook({
        initValue: DEFAULT_FORM,
        getDispatchAction,
        saveDispatchAction,
    });
};
